// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import ActionStrip from './actionStrip';
import CompaniesRows from './companiesRows';
import ProcessingApp from './processingApp';
import CaughtApp from './caughtApp';
import StylishDropdown from 'components/common/stylishDropdown/stylishDropdown';
import ApplicationInformation from './applicationInformation';
import { userGetPersonalInfo } from 'actions/user/user';
import moment from 'moment';


const okApplication = "Application is OK";

class Application extends Component {

  state: {
    applicationsPresent: boolean;
  };

  constructor(props) {
    super(props);
    this.state = {
      applicationsPresent: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentApp) {
      this.setState({ applicationsPresent: true });
    }
  }

  componentDidMount() {
    const { userGetPersonalInfo } = this.props
    userGetPersonalInfo();
  }

  _renderApplicationsOptionsList(app) {
    return (
      <option value={app.order_id} key={app.order_id}>{app.order_id}</option>
    )
  }

  _renderProductIcons(product) {
    return (
      <li key={product.id} className='product-icon'><i className={'ico ' + product.url_alias}></i></li>
    )
  }

  _dropDownItems() {
    let apps = this.props.apps.rows;
    apps = apps.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    if (apps) {
      let items = apps.map((item) => {
        return { id: item.id, value: item.order_id, order_id: item.order_id, text: 'ID: ' + item.order_id + ' | Dato: ' + moment(item.created_at).format('DD/MM/YYYY'), url: '' }
      });

      return items;
    }
  }

  _preventReminder() {
    const { currentApp } = this.props;
    if (!currentApp) { return };
    let active = true;
    const activeApp = currentApp.app_companies.length === 1 && !currentApp.app_companies[0].reminder_ws;
    if (currentApp.validation_message.value !== okApplication || activeApp) {
      active = false;
    }

    return !!active;
  }

  _getComponent(app) {
    if (app.validation_message.value !== okApplication) {
      return <CaughtApp />
    } else if (app.is_valid) {
      return app.processed ? <CompaniesRows /> : <ProcessingApp />
    } else {
      return null;
    }
  }

  render() {
    const { currentApp, translate } = this.props;
    if (!currentApp || !this.state.applicationsPresent) { return null; };
    let component = this._getComponent(currentApp);
    const firstItemLabel = 'ID: ' + currentApp.order_id + ' | Dato: ' + moment(currentApp.created_at).format('DD/MM/YYYY');

    return (
      <div className="application">
        <ApplicationInformation
          applicationID={currentApp.order_id}
          userName={currentApp.personal.name + ' ' + currentApp.personal.surname}
          userPhone={currentApp.personal.primary_phone}
          userEmail={currentApp.personal.email}
          businessName={currentApp.personal.business_name}
          translate={translate}
        />
        <h2>{translate('applications.in_place')}</h2>
        <div className="search-bar">
          <form>
            <div className="row">
              <div className="col-md-7 col-xs-12 pull-right text-right">
                <label htmlFor="lbl-04">{translate('applications.active_app')}</label>
                <StylishDropdown items={this._dropDownItems()} label={firstItemLabel} changeCallback={this.props._callbackSetApplication} />
              </div>
              <div className="col-md-5 col-xs-12">
                <h3>{translate('applications.my_insurance')}</h3>
                <ul className="icons">
                  {currentApp.products.map(this._renderProductIcons)}
                </ul>
              </div>
            </div>
          </form>
        </div>
        {currentApp.validation_message.value === okApplication &&
          <ActionStrip showReminder={this._preventReminder()} />}
        {component}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  apps: state.application.applications,
  currentApp: state.application.activeApplication
});

const mapDispatchToProps = {
  userGetPersonalInfo: userGetPersonalInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/application.js